export const FETCH_EMPLOYEE = "FETCH_EMPLOYEE";
export const SET_LOGGED_IN_EMPLOYEE = "SET_LOGGED_IN_EMPLOYEE";

